import React, { Component } from 'react';
import { Button, ButtonGroup, Col, FormGroup, Row } from 'reactstrap';
import HtmlHelpers from '../../HtmlHelpers';
export default class WmToggleField extends Component {
  constructor() {
    super(...arguments);
    this.sendToggle = selected => this.props.onChange({
      target: {
        name: this.props.name,
        value: selected
      }
    });
    this.getToggleField = () => /*#__PURE__*/React.createElement(Col, {
      md: this.props.fieldColumns
    }, /*#__PURE__*/React.createElement(ButtonGroup, null, /*#__PURE__*/React.createElement(Button, {
      outline: this.props.value === true,
      color: "info",
      onClick: () => this.sendToggle(false)
    }, this.props.label1), /*#__PURE__*/React.createElement(Button, {
      outline: this.props.value !== true,
      color: "info",
      onClick: () => this.sendToggle(true)
    }, this.props.label2)));
  }
  render() {
    return /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Row, {
      className: "align-items-center"
    }, HtmlHelpers.getWmLabel(this.props), this.getToggleField()));
  }
}